enum PAGE_TYPE {
  PERSON = 'person',
  SHIPPING = 'shipping',
  BILLING = 'billing',
  PAY_BILLING = 'pay_billing', // 收银台（信用卡支付）
  ADDRESS_LIB = 'address_lib', // 地址组件
}

export default PAGE_TYPE;
